export type StyleOption = {
  description: string;
  apiDescription: string;
  imgUrl?: string;
};

export const styleOptions: StyleOption[] = [
  {
    description: "Abstract Expressionism",
    apiDescription: "abstract expressionism",
    imgUrl: "/styles/abstract expressionism.png",
  },
  {
    description: "Flowy",
    apiDescription: "abstract flowy",
    imgUrl: "/styles/flowy.png",
  },
  {
    description: "Crystal Cubism",
    apiDescription: "crystal cubism",
    imgUrl: "/styles/crystal cubism.png",
  },
  {
    description: "Pop Art",
    apiDescription: "retro pop art comic",
    imgUrl: "/styles/pop art.png",
  },
  {
    description: "Pencil Sketch",
    apiDescription: "hand-drawn graphite pencil sketch",
    imgUrl: "/styles/pencil sketch.png",
  },
  {
    description: "Geometric Abstraction",
    apiDescription:
      "piet mondrian's geometric abstraction and de stijll art movement",
    imgUrl: "/styles/geometric abstraction.png",
  },
  {
    description: "Outline",
    apiDescription: "outline",
    imgUrl: "/styles/outline.png",
  },
  {
    description: "Pixel Art",
    apiDescription: "pixel art",
    imgUrl: "/styles/pixel art.png",
  },
  {
    description: "Pointilism",
    apiDescription: "pointilism",
    imgUrl: "/styles/pointilism.png",
  },
  {
    description: "Neon",
    apiDescription: "neon",
    imgUrl: "/styles/neon.png",
  },
  {
    description: "Ornamental",
    apiDescription: "ornamental art noveau",
    imgUrl: "/styles/ornamental.png",
  },
  {
    description: "Mascot",
    apiDescription: "mascot",
    imgUrl: "/styles/mascot.png",
  },
  {
    description: "Mosaic",
    apiDescription: "mosaic",
    imgUrl: "/styles/mosaic.png",
  },
  {
    description: "3D",
    apiDescription: "3d isometric",
    imgUrl: "/styles/3d.png",
  },
].sort((a, b) => a.description.localeCompare(b.description));
